import React from 'react';

/**
 * Återanvändbara action-knappar för uppföljning
 */
const FollowupActions = ({
  onSuggestTime,
  onBookMeeting,
  onApproveForCustomer,
  onBookHomeVisit,
  approveLoading = false,
  isApproved = false,
  disabled = false
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        className="text-xs px-3 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={onSuggestTime}
        disabled={disabled}
      >
        Föreslå tid
      </button>
      <button
        type="button"
        className="text-xs px-3 py-2 rounded bg-leadme-gray-dark text-white hover:bg-leadme-gray disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={onBookMeeting}
        disabled={disabled}
      >
        Boka uppföljning
      </button>
      {/* "Godkänn estimat åt kund" flyttad till knappraden högst upp i
          estimatet, bredvid "Visa kundvy" — den var svår att hitta här. */}
      {onBookHomeVisit && isApproved && (
        <button
          type="button"
          className="text-xs px-3 py-2 rounded flex items-center gap-1.5 bg-leadme-pink text-white hover:bg-leadme-pink-dark disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={onBookHomeVisit}
          disabled={disabled}
          title="Boka hembesök, föreslå tider eller hoppa över"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          Boka hembesök
        </button>
      )}
    </div>
  );
};

export default FollowupActions;
